export const EventsData = [
{
    id: "1",
    item: "Συναυλίες",
    value: "Συναυλίες"
},
{
    id: "2",
    item: "Θέατρο",
    value: "Θέατρο",
},
{
    id: "3",
    item: "Έκθεση",
    value: "Έκθεση",
},
{
    id: "4",
    item: "Κινηματογράφος",
    value: "Κινηματογράφος",
},
{
    id: "5",
    item: "Χορός",
    value: "Χορός",
},
{
    id: "6",
    item: "Εκδηλώσεις",
    value: "Εκδηλώσεις",
},
{
    id: "7",
    item: "Ρεσιτάλ",
    value: "Ρεσιτάλ",
},
{
    id: "8",
    item: "Συνέδριο",
    value: "Συνέδριο",
}
]